/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import CustomModal from "../../../../../components/Modal/CustomModal";
import CopySecretApp from "../Functionality/CopySecretApp";
import CustomWarningLegend from "../../../../../components/CustomWarningLegend";
import CustomDescriptionLabel from "../../../../../components/CustomDescriptionLabel";

const CopySecretModal = (props) => {
    const {secret, generatedPassword} = props;
    const {
        t,
        buttonText,
        handleConfirm,
        handleConfirmGeneratedPassword,
        onHideModal
    } = CopySecretApp(props);


    return (<>
        {
            generatedPassword ?
                <CustomModal
                    {...props}
                    title={"secret_key"}
                    size="lg"
                    cancelButton={false}
                    closeButton={false}
                    confirmButton={true}
                    onConfirm={handleConfirmGeneratedPassword}
                    buttonConfirm={buttonText}
                    onHide={onHideModal}
                    classNameBody="pt-2"
                >
                    <div className={"row"}>
                        <div className={"col-12 center-text"}>
                            <CustomDescriptionLabel trans={t("secret_key_and_password_warning")}/>
                        </div>
                        <div className={"col-12 center-text"}>
                            <CustomDescriptionLabel trans={t("copy_your_secret_key_and_password_to_continue")}/>
                        </div>
                        <div className={"col-12"}>
                            <CustomWarningLegend classes={""}>
                                <div className={"col-12 d-flex justify-content-center"}>
                                    <span className={"bold-text mr-2"}>{t("secret_key")}: </span>{secret}
                                </div>
                                <div className={"col-12 d-flex justify-content-center"}>
                                    <span className={"bold-text mr-2"}>{t("generated_password")}: </span>{generatedPassword}
                                </div>
                            </CustomWarningLegend>
                        </div>
                    </div>
                </CustomModal>

                :
                <CustomModal
                    {...props}
                    title={"secret_key"}
                    size="lg"
                    cancelButton={false}
                    closeButton={false}
                    confirmButton={true}
                    disabled={false}
                    onConfirm={handleConfirm}
                    buttonConfirm={buttonText}
                    onHide={onHideModal}
                    classNameBody="pt-2"
                >
                    <div className={"row"}>
                        <div className={"col-12 center-text"}>
                            <CustomDescriptionLabel trans={t("secret_key_warning")}/>
                        </div>
                        <div className={"col-12 center-text"}>
                            <CustomDescriptionLabel trans={t("copy_your_secret_key_to_continue")}/>
                        </div>
                        <div className={"col-12"}>
                            <CustomWarningLegend>{secret}</CustomWarningLegend>
                        </div>
                    </div>
                </CustomModal>
        }
    </>

    );
};

export default CopySecretModal;
